// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"5b6152b2","376":"075a9d0d","617":"aacc2de4","732":"10dff5b9","847":"fee5bd15","906":"3daebfca","977":"313a9597"}[chunkId] + ".chunk.js";
};